<template>
  <div class="n-footer">
    <div class="container">
      <!-- logo -->
      <div class="f-logo">
        <h2>北京猫闪科技有限公司</h2>
      </div>

      <!-- 介绍 -->
      <div class="f-jj">
        <!-- <h2>公司介绍</h2> -->
        <p>
          营范围包括计算机软硬件的技术开发、技术咨询、技术转让、技术培训、技术服务；销售计算机、软硬件及外围设备、五金交电、电子元器件、机械、电器设备、通讯设备；维修计算机、手机等...
        </p>
      </div>
      <!-- 信息 -->
      <div class="f-info">
        <p>公司名称：北京猫闪科技有限公司</p>
        <p>网站域名：moreshine.cn</p>
        <p>网站邮箱：moreshine@moreshine.cn</p>
        <p>联系地址：北京市海淀区中关村大街18号科贸电子城5C51-2</p>
        <p>
          网站备案：<a href="https://beian.miit.gov.cn/#/Integrated/index"
            >京ICP备2022027983号-1</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.n-footer {
  width: 100%;
  height: 200px;
  background-color: #292f32;

  .container {
    height: 100%;
    @include flex();
    .f-logo {
      width: 300px;
      height: 100%;
      h2 {
        font-size: 18px;
        color: #fff;
        line-height: 200px;
      }
    }
    .f-jj {
      width: 300px;
      //   height: 100%;
      h2 {
        font-size: 16px;
        color: #fff;
        margin-bottom: 20px;
      }
      p {
        font-size: 12px;
        color: #888;
        display: -webkit-box;
        line-height: 20px;
        text-indent: 30px;
      }
    }
    .f-info {
      width: 400px;
      p {
        font-size: 12px;
        color: #888;
        margin: 15px 0;
        a {
          color: #888;
          font-size: 12px;
        }
      }
    }
  }
}
</style>